/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCoolingRegimeTemperatureDtoFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeUpsertCommand, type CoolingRegimeTemperatureDto, type ProblemDetails, type UpsertCommand, type ValidationProblemDetails } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v{version}/CoolingRegimeTemperatures/{id}
 */
export interface CoolingRegimeTemperaturesItemRequestBuilder extends BaseRequestBuilder<CoolingRegimeTemperaturesItemRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 405 status code
     * @throws {ProblemDetails} error when the service returns a 429 status code
     * @throws {ProblemDetails} error when the service returns a 500 status code
     * @throws {ProblemDetails} error when the service returns a 502 status code
     * @throws {ProblemDetails} error when the service returns a 503 status code
     * @throws {ProblemDetails} error when the service returns a 504 status code
     */
     delete(requestConfiguration?: RequestConfiguration<CoolingRegimeTemperaturesItemRequestBuilderDeleteQueryParameters> | undefined) : Promise<void>;
    /**
     * Gets the cooling regime temperature.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CoolingRegimeTemperatureDto>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 405 status code
     * @throws {ProblemDetails} error when the service returns a 500 status code
     * @throws {ProblemDetails} error when the service returns a 502 status code
     * @throws {ProblemDetails} error when the service returns a 503 status code
     * @throws {ProblemDetails} error when the service returns a 504 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CoolingRegimeTemperatureDto | undefined>;
    /**
     * @param body Class UpsertCommand.Implements the CoolingRegimeGenusDto            
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 405 status code
     * @throws {ProblemDetails} error when the service returns a 429 status code
     * @throws {ProblemDetails} error when the service returns a 500 status code
     * @throws {ProblemDetails} error when the service returns a 502 status code
     * @throws {ProblemDetails} error when the service returns a 503 status code
     * @throws {ProblemDetails} error when the service returns a 504 status code
     */
     put(body: UpsertCommand, requestConfiguration?: RequestConfiguration<CoolingRegimeTemperaturesItemRequestBuilderPutQueryParameters> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<CoolingRegimeTemperaturesItemRequestBuilderDeleteQueryParameters> | undefined) : RequestInformation;
    /**
     * Gets the cooling regime temperature.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body Class UpsertCommand.Implements the CoolingRegimeGenusDto            
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpsertCommand, requestConfiguration?: RequestConfiguration<CoolingRegimeTemperaturesItemRequestBuilderPutQueryParameters> | undefined) : RequestInformation;
}
export interface CoolingRegimeTemperaturesItemRequestBuilderDeleteQueryParameters {
    culture?: string;
}
export interface CoolingRegimeTemperaturesItemRequestBuilderPutQueryParameters {
    culture?: string;
}
/**
 * Uri template for the request builder.
 */
export const CoolingRegimeTemperaturesItemRequestBuilderUriTemplate = "{+baseurl}/api/v{version}/CoolingRegimeTemperatures/{id}{?culture*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const CoolingRegimeTemperaturesItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: CoolingRegimeTemperaturesItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            405: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            429: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            502: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            504: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    get: {
        uriTemplate: CoolingRegimeTemperaturesItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            405: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            502: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            504: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCoolingRegimeTemperatureDtoFromDiscriminatorValue,
    },
    put: {
        uriTemplate: CoolingRegimeTemperaturesItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            405: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            429: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            502: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            503: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            504: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpsertCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
